import { cn } from "@/betby/lib/utils";
import gcSwitch from "@/betby/assets/image/gc-switch.webp";
import scSwitch from "@/betby/assets/image/sc-switch.webp";
import { useCurrencySwitchViewModel } from "@/betby/viewmodels/useCurrencySwitchViewModel";
import { useProduct } from "@/betby/hooks/useProduct";

export default function CurrencySwitch() {
  const { isGC, handleToggle } = useCurrencySwitchViewModel();
  const { isWinburst } = useProduct();
  return (
    <button
      onClick={handleToggle}
      className={cn(
        "relative w-[60px] h-[34px] rounded-full transition-all duration-300 ease-in-out",
        "bg-black/25",
        // "focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#321F48] focus:ring-[#4A2F5F]",
        "hover:opacity-90 cursor-pointer",
        "shadow-inner",
      )}
      role="switch"
      aria-checked={!isGC}
      aria-label={`Switch to ${isGC ? "SC" : "GC"} currency`}
    >
      {/* 切换圆形按钮 */}
      <div
        className={cn(
          "absolute top-1/2 -translate-y-1/2 w-[25px] h-[25px] rounded-full",
          "flex items-center justify-center transition-all duration-300 ease-in-out",
          "shadow-md",
          isGC
            ? "left-[2px]" // GC模式：金色，在左侧
            : "left-[30px]", // SC模式：绿色，在右侧
        )}
      >
        <img
          src={isGC ? gcSwitch : scSwitch}
          alt={isGC ? "GC" : "SC"}
          width={25}
          height={25}
          className="object-contain"
        />
      </div>
    </button>
  );
}
